// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__NIPuQ","title":"Stats_title__U+eow","subtitle":"Stats_subtitle__F8C0U","cards":"Stats_cards__K5ko0"};